/**
 * Identificatori dei campi della ricevuta di invio configurabili tramite la
 * variabile d'ambiente `RECEIPT_VISIBLE_FIELDS`. I valori corrispondono alle
 * stringhe ammesse nella CSV.
 */
export enum ReceiptField {
  Status = 'status',
  ProcedureNumber = 'procedureNumber',
  InstanceNumber = 'instanceNumber',
  SubmissionDate = 'submissionDate',
  ProcedurePhase = 'procedurePhase',
  ProcedureManagerOffice = 'procedureManagerOffice',
  ProcedureManager = 'procedureManager',
}

/**
 * Insieme degli identificatori gestiti, usato per validare i valori letti
 * dalla variabile d'ambiente. Derivato dall'enum così che ogni nuovo valore
 * sia automaticamente accettato.
 */
const configurableReceiptFields = new Set<string>(Object.values(ReceiptField));

/**
 * Guardia che verifica se l'identificatore è un campo configurabile della
 * ricevuta.
 */
export function isConfigurableReceiptField(
  field: string,
): field is ReceiptField {
  return configurableReceiptFields.has(field);
}
